var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShareX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.71 10.617 20.415 3h-1.59l-5.816 6.613L8.359 3H3l7.027 10.004L3 20.992h1.59l6.14-6.988 4.91 6.988H21Zm-2.17 2.473-.716-.996L5.16 4.168h2.438l4.574 6.398.71.997 5.946 8.312h-2.441Zm0 0"
})));
export default SvgShareX;